import {
  FilterMode,
  MusicalWorkCreateMutationVariables,
  MusicalWork_OrderBy,
  MusicalWork,
  SortOrder,
  MusicalWork_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";
import { buildCreateOne } from "../../common/services/crudServices";

export const musicalWorkService = {
  createOne: buildCreateOne(
    (musicalWorkCreateVariables: MusicalWorkCreateMutationVariables) =>
      async (token: string, activityStore: any) => {
        const api = getApiInstance(token, activityStore);
        const result = await api.musicalWorkCreate(musicalWorkCreateVariables);
        return result.musicalWorkCreate;
      }
  ),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.musicalWorkOne({ id });
    return result.musicalWorkOne as MusicalWork;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: MusicalWork_OrderBy[] | null = null,
    filter: MusicalWork_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: MusicalWork_Filter | undefined;
    if (searchValue !== "") {
      where = {
        title: { contains: searchValue, mode: FilterMode.Insensitive },
      };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.musicalWorkListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : [{ title: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.musicalWorkListWithOffset
    ) as MusicalWork[];
    return { list, orderBy };
  },
};
